<template>
  <form @submit.prevent="submit()" autocomplete="off" id="issueForm" v-on:keypress.enter.prevent="enterKey">
    <div class="mt-3">
      <div class="row mx-1">
        <div class="col-12 col-md-12">
          <div class="form-group">
            <label class="generalLabel" for="comment"><span className='text-danger'>*</span>Añadir Comentario</label>
            <textarea class="form-control generalInput" id="comment" v-model.trim.lazy="v$.comment.$model" maxlength="500"
              rows="6"></textarea>
            <div v-if="v$.comment.$dirty">
              <small class="form-text text-danger" v-if="v$.comment.required.$invalid">Campo requerido</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="content === 'content2'">
      <label class="generalLabel ml-3">{{ message }}</label>
    </div>
    <div class="mx-auto row mt-3">
      <button class="btn btn-primary float-right generalPrimaryButton mx-auto" id="submitButton"
        v-bind:class="{ disabled: v$.$invalid || loading }" :disabled="v$.$invalid || loading" @click="submit($event)">
        <span v-if="loading">
          <img src="../../../../../assets/loader.svg" height="25" alt="">
        </span>
        <span v-else>Enviar</span>
      </button>
    </div>
    <p class="generalTitleItemModal mt-5 mb-3">COMENTARIOS</p>
  </form>
</template>


<script>
import axios from 'axios';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators'


export default {
  name: 'NewComment',
  props: [
    'issue',
  ],
  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      comment: "",
      content: 'content1',
      loading: false,
      message: ""
    };
  },
  validations() {
    return {
      comment: {
        required,
      },
    }
  },
  methods: {
    clean() {
      this.comment = ''
    },
    async submit() {
      this.loading = true;
      const bodyToSend = {
        comment: this.comment,
      }
      await axios.post(`/incident/${this.issue.incidentId}/comment`, bodyToSend)
        .then(() => {
          this.selectTab('content2');
          this.loading = false
          setTimeout(() => {
            this.message = 'Se ha realizado la operación correctamente.';
          }, 10000);
          this.$emit("sendRefreshIssuesList", this.issue.incidentId);
          this.comment = ''

        })
        .catch(() => {
          this.loading = false;
          this.selectTab('content2');
          this.message = 'Ha ocurrido un error al realizar la operación.';
        });
    },

    selectTab(id) {
      this.content = id;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.vue-select {
  z-index: 20;
}
</style>